import React from 'react'
import { Card, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'

const AwaitingLabellingTaskList = ({ awaitingLabelling, onSelectTask, onSelectPrint }) => {
	return (
		<div className="awaiting-labelling-task-list">
			<h4>Awaiting Labelling</h4>
			{(awaitingLabelling?.length === 0) && <div>No available awaiting labelling tasks .</div>}
			{awaitingLabelling?.map((task, idx) => (
				<Card key={task.id || idx} className="awaiting-labelling-task-card mb-3">
					<Card.Body>
						<div className="awaiting-labelling-task-row">
							<span className="awaiting-labelling-task-label">Customer:</span>
							<span className="awaiting-labelling-task-value">{task.customerName}</span>
						</div>
						<div className="awaiting-labelling-task-row">
							<span className="awaiting-labelling-task-label">Picked By:</span>
							<span className="awaiting-labelling-task-value">{task.picker}</span>
						</div>
						<div className="awaiting-labelling-task-row">
							<span className="awaiting-labelling-task-label">Picked Items:</span>
							<span className="awaiting-labelling-task-value">{task.quantityPicked}</span>
						</div>
						<div className="awaiting-labelling-task-row">
							<span className="awaiting-labelling-task-label">Ordered Items:</span>
							<span className="awaiting-labelling-task-value">{task.quantityOrdered}</span>
						</div>
						<Button variant="info" className="mt-3 w-100" onClick={() => onSelectTask?.(task)}>
							View Articles
						</Button>
						<Button variant="primary" className="mt-3 w-100" onClick={() => onSelectPrint?.(task)}>
							Print labels
						</Button>
					</Card.Body>
				</Card>
			))}
		</div>
	)
}

AwaitingLabellingTaskList.propTypes = {
	awaitingLabelling: PropTypes.array.isRequired,
	onSelectTask: PropTypes.func,
	onSelectPrint: PropTypes.func
}


export default AwaitingLabellingTaskList